import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { IntercomProvider } from "react-use-intercom";
import store from "./app-store/store";
import { Provider } from "react-redux";

ReactDOM.render(
  <React.StrictMode>
    <ToastContainer />
    <IntercomProvider appId={process.env.REACT_APP_INTERCOM_APP_ID}>
      <Provider store={store}>
        <App />
      </Provider>
    </IntercomProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
